// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__nTOF8","fill":"ProgressBar_fill__3p3Dn"};